let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6SDRc")).then(() => parcelRequire('3Qt72'));